import classNames from 'classnames';
import React from 'react';
import './style.css';

interface IconProps {
    /**
     * Optional class to add to the parent element
     */
    className?: string;
    /**
     * Text shown under the icon.
     */
    label?: string;
    /**
     * URL of image shown when the image icon is not hovered.
     */
    imageUrl?: string;
    /**
     * URL of the image shown when the image is hovered.
     */
    imageUrlAlt?: string;
    /**
     * Diameter of the icon
     */
    diameter: number;
    /**
     * Size of the font for the label
     */
    fontSize: number;
    /**
     * Fired when the icon is clicked.
     */
    onClick?: () => void;
    /**
     * Visited when the icon is clicked
     */
    href?: string;
}
/**
 * Displays an icon with an optional label below it.
 * If the icon has a click handler, it will have the "clickable" class.
 */
const Icon = ({
    className,
    diameter,
    imageUrl,
    imageUrlAlt,
    label,
    fontSize,
    onClick,
    href,
}: IconProps) => {
    const cls = classNames('svg-icon', { clickable: !!onClick }, className);

    return <Icon.ConditionalLink
                href={href && !onClick ? href : undefined}>
            <g className={cls} onClick={onClick || (() => { })}>
            {label &&
                <text className="svg-icon-label"
                    fontSize={fontSize}
                    x={0}
                    y={(diameter / 2) + fontSize}
                >{label.toLowerCase()}</text>
            }
            <g className="svg-icon-image"
                    transform={`translate(${-diameter / 2} ${-diameter / 2})`}>
                <image
                    width={diameter}
                    height={diameter}
                    xlinkHref={imageUrl}
                    />
                {imageUrlAlt &&
                    <image className="svg-icon-image-alt"
                        width={diameter}
                        height={diameter}
                        xlinkHref={imageUrlAlt}
                    />
                }
            </g>
        </g>
    </Icon.ConditionalLink>;
};

Icon.ConditionalLink = ({href, children}) =>
    href ? <a href={href}>{children}</a> :
    <>{children}</>;

export default Icon;
